/** Default Black Sigatoka range: recent days plus the IFS forecast horizon. */

function isoDate(day: Date): string {
  const y = day.getFullYear();
  const m = String(day.getMonth() + 1).padStart(2, '0');
  const d = String(day.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function defaultBsriDateRange(): { start_date: string; end_date: string } {
  const start = new Date();
  start.setDate(start.getDate() - 6);
  const end = new Date();
  end.setDate(end.getDate() + 14);
  return { start_date: isoDate(start), end_date: isoDate(end) };
}
